import { render } from "./CustomModelInput.vue?vue&type=template&id=644ab18e&scoped=true"
import script from "./CustomModelInput.vue?vue&type=script&lang=js"
export * from "./CustomModelInput.vue?vue&type=script&lang=js"

import "./CustomModelInput.vue?vue&type=style&index=0&id=644ab18e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644ab18e"]])

export default __exports__